<template>
  <div>
    <NavHeader :activeIndex="'RealTimeReports'"  />

    <b-card-header class="bg-white">
      <div class="col-12 d-flex justify-content-between align-items-center ">

        <div class="fs-lg-19 fs-sm-10 fs-md-20 fw-semibold text-black"> <span class="text-primary">{{ chooseTypeName }}
          </span>最近七天战报查询</div>
        <div class="me-20">
          <b-dropdown :text="chooseTypeName" variant="flat-primary">
            <b-dropdown-item @click="chooseHistroy('dxq', '01')">
              走地大小球
            </b-dropdown-item>
            <b-dropdown-item @click="chooseHistroy('rq', '01')">
              走地让球
            </b-dropdown-item>
            <b-dropdown-item @click="chooseHistroy('jq', '01')">
              走地角球
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </div>
    </b-card-header>

    <div class="card-content mt-20">
      <div class="row">
        <swiper class="swiper-coverflow" :options="swiperOptions" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'">
          <swiper-slide v-for="card in card_list" :key="card.matchId" style="cursor:pointer;">
            <div @click="showHisDetail(card)">
              <div class="card mb-25 border-0 rounded-0  seller-card">
                <div class="card-body letter-spacing">
                  <div class="mb-15 mb-md-20 mb-lg-25 d-flex align-items-center justify-content-between">
                    <div class="icon position-relative text-center  rounded-circle">
                      <feather-icon icon="ActivityIcon" size="50" class="mt-15" />
                    </div>
                    <div>
                      <h5 class="fs-18 fw-semibold text-black mb-5 mb-md-8">{{ card.day }}</h5>
                      <span class="text-paragraph d-block">胜率: <span class="text-primary fw-semibold">{{ card.sl
                          }}%</span></span>
                    </div>
                    <div class="dropdown">
                      <span class="text-primary">查看</span>
                    </div>
                  </div>

                  <ul class="list mt-15 mt-lg-25  mb-0 list-unstyled d-flex justify-content-between">
                    <li>
                      <span class="d-block text-dark text-uppercase fw-medium fs-12 mb-5 mb-md-8">总场次</span>
                      <span class="d-block  fw-medium ">
                        <b-avatar rounded variant="light-info" :text="card.zcc+''" />
                      </span>
                    </li>
                    <li>
                      <span class="d-block text-dark text-uppercase fw-medium fs-12 mb-5 mb-md-8">正确场次</span>
                      <span class="d-block text-dark fw-medium text-success">
                        <b-avatar rounded variant="light-success" :text="card.zqcc+''" /></span>
                    </li>
                    <li>
                      <span class="d-block text-dark text-uppercase fw-medium fs-12 mb-5 mb-md-8">错误场次</span>
                      <span class="d-block text-dark fw-medium ">
                        <b-avatar rounded variant="light-danger" :text="card.cwcc+''" /></span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </swiper-slide>
          <div slot="pagination" class="swiper-pagination" />

          <!-- Add Arrows -->
          <div slot="button-next" class="swiper-button-next" />
          <div slot="button-prev" class="swiper-button-prev" />
        </swiper>

      </div>



      <div class="card mb-25 border-0 rounded-0 bg-white">
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
          <div class="table-responsive">
            <table class="table text-nowrap align-middle mb-0">
              <thead>
                <tr>
                  <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13  ">
                    联赛名
                  </th>
                  <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 ">
                    比赛时间
                  </th>
                  <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 ">
                    主队
                  </th>
                  <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 ">
                    比分
                  </th>
                  <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 ">
                    客队
                  </th>
                  <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 ">
                    提示时间
                  </th>
                  <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 ">
                    提示盘口
                  </th>
                  <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 ">
                    提示比分
                  </th>
                  <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 ">
                    提示类型
                  </th>

                  <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 ">
                    结果
                  </th>
                </tr>
              </thead>


              <tbody>
                <tr v-for="item in resultData" :key="item.matchId">
                  <th class="shadow-none title lh-1 fw-medium fs-md-15 fs-lg-16 ">
                    <div class="d-flex align-items-center">

                      <img v-if="item.gameImg != null" :src="`http://lcsjfx.com/football/${item.gameImg}`"
                        class="rounded-circle " width="20" height="20" alt="user" />
                      <span class="d-block text-primary">{{ item.gameName }} </span>
                    </div>
                  </th>
                  <td>
                    {{ item.matchTime.substring(5) }}

                  </td>
                  <td class="shadow-none lh-1">
                    <div class="d-flex align-items-center">
                      <img v-if="item.homeImg != null" :src="`http://lcsjfx.com/football/${item.homeImg}`" width="20"
                        height="20" class="rounded-1 me-10" alt="project-image" />

                      <span class="d-block me-10">{{ item.teams1 }}</span>
                    </div>
                  </td>
                  <td class="shadow-none lh-1">
                    <div class="d-flex align-items-center">

                      <span class="fw-bold text-success text-badge d-inline-block me-10">
                        <h6 class="fw-black mb-0">{{ item.lastScore.split('-')[0] }}</h6>
                      </span>
                      ：
                      <span class="fw-bold text-danger text-badge d-inline-block me-10">
                        <h6 class="fw-black mb-0">{{ item.lastScore.split('-')[1] }}</h6>
                      </span>

                    </div>
                  </td>
                  <td class="shadow-none lh-1">
                    <div class="d-flex align-items-center">
                      <span class="d-block me-10">{{ item.teams2 }}</span>
                      <img v-if="item.guestImg != null" :src="`http://lcsjfx.com/football/${item.guestImg}`" width="20"
                        height="20" class="rounded-1 me-10" alt="project-image" />

                    </div>
                  </td>
                  <td class="shadow-none lh-1 fw-bold text-body-tertiary text-warning">
                    {{ item.status }} ′
                  </td>
                  <td class="shadow-none lh-1 fw-bold text-body-tertiary ">
                    <span class="text-danger">{{ item.handicap }}</span>
                  </td>
                  <td class="shadow-none lh-1 fw-medium text-body-tertiary">
                    <span class="text-primary">{{ item.score }}</span>
                  </td>
                  <td class="shadow-none lh-1 fw-medium">
                    <span class="badge bg-primary fs-10"
                      v-if="item.betTypeStr.includes('大') || item.betTypeStr.includes('主') || item.betTypeStr == '胜'">{{
                        item.betTypeStr }}</span>
                    <span class="badge bg-info fs-10"
                      v-if="item.betTypeStr.includes('小') || item.betTypeStr.includes('客') || item.betTypeStr.includes('负')">{{
                        item.betTypeStr }}</span>
                    <span class="badge bg-dark fs-10" v-if="item.betTypeStr.includes('平')">{{ item.betTypeStr }}</span>
                  </td>

                  <td class="shadow-none lh-1 fw-medium text-body-tertiary">
                    <span class="text-danger fs-20 " v-if="item.jsStatusStr === '赢' || item.jsStatusStr === '赢半'">
                      <feather-icon icon="CheckIcon" size="20" />
                    </span>
                    <span class="text-dark" v-else-if="item.jsStatusStr === '走水'">{{ item.jsStatusStr }}</span>
                    <span class="text-dark" v-else></span>

                  </td>
                </tr>
              </tbody>
            </table>

            <div class="text-center p-4 bg-primary text-light rounded mt-20" v-if="resultData.length == 0">
              <!-- <b-icon icon="cloud-upload" font-scale="4" /> -->
              <feather-icon icon="UploadCloudIcon" size="40" class="blinking" />
              <div class="mb-3 mt-20">
                点击上方“查看”按钮，进行查询明细<span class="blinking">...</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import request from '@/utils/request.js';
import vSelect from 'vue-select'

import NavHeader from './NavHeader.vue'

export default {
  components: {
    NavHeader,
    Swiper,
    SwiperSlide,
    vSelect,
  },
  data() {
    return {
      card_list: [],
      resultData: [],
      activate_card: '',
      chooseType: '',
      chooseTypeName: '',
      chooseLx: '',
      swiperOptions: {
        slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: 30,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
        pagination: {
          el: '.swiper-pagination',
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
    };
  },
  created() {
    this.chooseType = this.$route.query.searchType + "";
    this.chooseLx = this.$route.query.searchLx + "";
    this.changeTypeName(this.chooseType);
  },
  mounted() {
    this.chooseType = 'dxq';
    this.chooseLx = '01';
    this.chooseTypeName = '走地大小球';
    this.getHistroy();
  },
  methods: {
    chooseHistroy(c_type, c_lx) {
      this.card_list = [];
      this.resultData = [];
      this.chooseType = c_type;
      this.chooseLx = c_lx;
      this.changeTypeName(this.chooseType);
      this.getHistroy();
    },
    changeTypeName(c_type) {
      if (c_type == 'dxq') {
        this.chooseTypeName = '走地大小球';
      }
      if (c_type == 'rq') {
        this.chooseTypeName = '走地让球';
      }
      if (c_type == 'jq') {
        this.chooseTypeName = '走地角球';
      }
      if (c_type == 'cpdxq') {
        this.chooseTypeName = '大小球分析';
      }
      if (c_type == 'cprq') {
        this.chooseTypeName = '亚盘分析';
      }
    },
    async showHisDetail(card) {
      this.activate_card = card;
      let post_url = 'football/admin/william/interfaceAction!getRecordDetail.action';
      post_url = post_url + '?id=' + card.recordId + "&matchTime=" + card.day;
      let opts = {
        type: 1, //1为数据接口；2为静态资源请求
        url: post_url,
        method: 'get'
      };
      await request.openHttpRequest(opts).then(response => {
        if (response == null) {
          // this.$message.error('网络连接异常');
          return;
        }
        if (response.data.status == 0) {
          return;
        }
        this.resultData = response.data.RecordDetail;
      });
    },

    async getHistroy() {
      await this.getHistroyList(this.chooseType, this.chooseLx);
    },


    async getHistroyList(sjlx, yclx) {
      let post_url = 'football/admin/william/interfaceAction!getRecordDay.action';
      post_url = post_url + "?sjlx=" + sjlx + "&yclx=" + yclx;
      let opts = {
        type: 1, //1为数据接口；2为静态资源请求
        url: post_url,
        method: 'get'
      };
      await request.openHttpRequest(opts).then(response => {

        if (response == null) {
          // this.$message.error('网络连接异常');
          return;
        }
        if (response.data.status == 0) {
          // this.$message.error(response.data.message);
          return;
        }
        let data = response.data.RecordDay;
        this.card_list = data;
      });
    },
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/swiper.scss';
@import '@core/scss/vue/libs/vue-select.scss';
</style>
